var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1222(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M264.79,978.517l554.923,0.198c0,0 193.843,-20.622 196.674,-211.737c2.979,-201.095 -208.366,-213.649 -214.064,-223.697c-42.327,-74.639 -71.103,-175.251 -256.716,-176.317c-229.911,-1.319 -262.65,268.944 -271.883,271.099c-69.494,16.214 -178.887,42.333 -177.724,185.234c1.166,143.227 168.79,155.22 168.79,155.22Z",
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.174,621.998c-75.742,18.1 -184.141,51.801 -182.923,201.451c0.656,80.602 47.906,124.434 95.235,147.959c45.551,22.641 90.966,25.812 90.966,25.812c0.443,0.031 0.887,0.047 1.331,0.047l554.923,0.198c0.665,0 1.33,-0.035 1.991,-0.105c-0,-0 210.364,-22.544 213.438,-230.104c2.866,-193.524 -177.03,-226.366 -219.465,-238.522c-25.4,-45.878 -48.029,-99.398 -101.019,-136.149c-37.33,-25.89 -89.663,-43.915 -168.936,-44.37c-111.324,-0.639 -179.79,57.709 -222.217,122.504c-39.419,60.199 -55.714,125.941 -63.324,151.279Zm5.345,337.766c-5.044,-0.453 -40.626,-4.185 -76.341,-21.937c-36.775,-18.278 -73.919,-52.057 -74.429,-114.683c-1.057,-129.927 100.051,-152.079 163.236,-166.822c3.243,-0.757 7.302,-2.466 10.901,-6.914c1.134,-1.402 2.633,-3.69 4.007,-7.066c1.913,-4.698 4.641,-14.652 8.583,-28.183c19.177,-65.826 71.675,-229.434 244.023,-228.445c69.218,0.397 115.186,15.079 147.781,37.685c49.846,34.571 68.595,86.566 92.733,129.131c1.454,2.564 4.209,6.12 9.69,8.811c3.977,1.953 13.466,4.481 26.641,7.905c52.347,13.603 177.486,49.52 175.295,197.454c-2.479,167.339 -165.332,191.526 -178.998,193.261c-0.028,0.004 -553.079,-0.193 -553.079,-0.193l-0.043,-0.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M777.497,159.866l-0,-104.18",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.54,434.143l104.18,-0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.178,166.563l73.666,73.666",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.91,165.047l-73.667,73.666",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M509.81,1124l-160.5,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.916,1053.74l-80.25,138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.685,1192.54l-80.25,-138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M775.023,1124l-160.5,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.129,1053.74l-80.25,138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.898,1192.54l-80.25,-138.997",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M887.586,564.255c22.557,-19.02 39.809,-43.554 50.076,-71.217c32.834,-88.465 -12.332,-186.945 -100.797,-219.78c-88.525,-32.856 -186.924,12.272 -219.78,100.797",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "37.5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1222);
export default __webpack_public_path__ + "static/media/1222.b5ebe3f6789a4daffc54d4b4adca8484.svg";
export { ForwardRef as ReactComponent };